import { useEffect } from 'react';
import { getModule } from '@jwp/ott-common/src/modules/container';
import AccountController from '@jwp/ott-common/src/controllers/AccountController';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';

export const useReloadUserSession = () => {
  useEffect(() => {
    let lastRefreshTimestamp = Date.now();

    const handleBrowserFocus = async () => {
      const accountController = getModule(AccountController);
      const isLoggedIn = !!useAccountStore.getState().user;

      if (Date.now() - lastRefreshTimestamp < 60_000) {
        return;
      }

      lastRefreshTimestamp = Date.now();

      // reload the user session and subscriptions
      if (isLoggedIn) {
        await accountController.loadUserData(true);
        await accountController.reloadSubscriptions();
      }
    };

    window.addEventListener('focus', handleBrowserFocus);

    return () => {
      window.removeEventListener('focus', handleBrowserFocus);
    };
  }, []);
};
